// @ts-nocheck
"use client";

import { useCallback, useRef, useState } from "react";

import markdownToTxt from "markdown-to-txt";
import Markdown from "react-markdown";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import remarkGfm from "remark-gfm";

// @ts-nocheck

export default function MarkdownViewerClient() {
  const textRef = useRef<any>(null);
  const [markdown, setMarkdown] = useState("");

  const handleTextChange = useCallback(() => {
    setMarkdown(textRef.current.value);
  }, []);

  return (
    <div className="flex justify-center overflow-x-hidden">
      <div className="flex min-h-[500px] w-full max-w-screen-3xl flex-col items-center p-4 md:p-10">
        <h1 className="mb-4 text-center font-heading text-4xl font-bold">
          Markdown Viewer
        </h1>
        <div>
          <p className="mx-auto mb-10 text-center text-muted-foreground lg:w-2/3">
            Stop squinting at code and unlock the magic of your Markdown.
            Simply paste your text into our viewer and watch it transform into
            beautiful, formatted rich text. No fiddling with settings, just
            effortless previews that showcase your ideas exactly as you
            intend. Whether you&apos;re a writer, developer, or just love the
            simplicity of Markdown, our viewer is your perfect writing
            companion. See your content flourish and share it with confidence,
            all in a flash.
          </p>
        </div>
        <div className="w-full">
          <div className="flex w-full flex-col md:flex-row md:justify-around">
            <textarea
              ref={textRef}
              className="textarea textarea-bordered mb-4 mr-2 min-h-[500px] w-full p-4 text-base placeholder:italic dark:bg-[#08131c]"
              placeholder="Enter Markdown Content..."
              onChange={handleTextChange}
            />
            <Markdown
              id="markdown-viewer-tool"
              className="markdown textarea textarea-bordered mb-4 min-h-[500px] w-full p-4 text-base placeholder:italic dark:bg-[#08131c] md:ml-2"
              remarkPlugins={[remarkGfm]}
              components={{
                code(props) {
                  const { children, className, _, ...rest } = props;
                  const match = /language-(\w+)/.exec(className || "");
                  return match ? (
                    <SyntaxHighlighter
                      {...rest}
                      PreTag="div"
                      language={match[1]}
                    >
                      {String(children).replace(/\n$/, "")}
                    </SyntaxHighlighter>
                  ) : (
                    <code {...rest} className={className}>
                      {children}
                    </code>
                  );
                },
                a: ({ href, children }) => (
                  <a href={href} target="_blank" rel="noopener noreferrer">
                    {children}
                  </a>
                ),
              }}
            >
              {markdown}
            </Markdown>
          </div>
          {markdown?.length > 0 && (
            <div className="my-10 w-full text-center">
              <strong>Characters:</strong> ~{markdownToTxt(markdown)?.length}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
